import useRegion from '@/hooks/providers/useRegion';

import { useRegionalConfiguration } from './useRegionalConfiguration';

export const useGetConfigByKey = <T>(route: string, fallback?: T): T | undefined => {
    const { region } = useRegion();
    const { getConfigByKey } = useRegionalConfiguration({
        region,
    });

    return getConfigByKey(route, fallback) as T | undefined;
};
